module.exports = __webpack_public_path__ + "img/V-L-3-unload-connect.1fdbf51c.png";